import * as THREE from "three";

export class SphereGeometry extends THREE.Geometry {


    constructor(radius: number, deltaLat: number, deltaLong: number) {
        super();

        var latLayers = 180 / deltaLat;
        var lngSegments = 360 / deltaLong;

        var lat, lng, vertices = [], uvs = [];

        for (lat = -90; lat <= 90; lat += deltaLat) {

            var verticesRow = [];
            var uvsRow = [];
            var radLat = THREE.MathUtils.degToRad(lat);
            var z = radius * Math.sin(radLat);
            var cosLat = radius * Math.cos(radLat);
            var v = (lat + 90) / 180;

            for (lng = -180; lng <= 180; lng += deltaLong) {

                var vertex = new THREE.Vector3();
                var radLng = THREE.MathUtils.degToRad(lng);
                vertex.x = cosLat * Math.cos(radLng);
                vertex.y = cosLat * Math.sin(radLng);
                vertex.z = z;

                this.vertices.push(vertex);

                verticesRow.push(this.vertices.length - 1);
                var u = (lng + 180) / 360;
                uvsRow.push(new THREE.Vector2(u, v));

            }

            vertices.push(verticesRow);
            uvs.push(uvsRow);

        }

        for (var y = 0; y < latLayers; y++) {

            for (var x = 0; x < lngSegments; x++) {

                var v1 = vertices[y][x + 1];
                var v2 = vertices[y][x];
                var v3 = vertices[y + 1][x];
                var v4 = vertices[y + 1][x + 1];

                var uv1 = uvs[y][x + 1].clone();
                var uv2 = uvs[y][x].clone();
                var uv3 = uvs[y + 1][x].clone();
                var uv4 = uvs[y + 1][x + 1].clone();

                if (Math.abs(this.vertices[v1].z) === radius) {

                    uv1.x = (uv1.x + uv2.x) / 2;
                    this.faces.push(new THREE.Face3(v1, v4, v3));
                    this.faceVertexUvs[0].push([uv1, uv4, uv3]);

                } else if (Math.abs(this.vertices[v3].z) === radius) {

                    uv3.x = (uv3.x + uv4.x) / 2;
                    this.faces.push(new THREE.Face3(v1, v3, v2));
                    this.faceVertexUvs[0].push([uv1, uv3, uv2]);

                } else {

                    this.faces.push(new THREE.Face3(v1, v4, v2));
                    this.faceVertexUvs[0].push([uv1, uv4, uv2]);

                    this.faces.push(new THREE.Face3(v2, v4, v3));
                    this.faceVertexUvs[0].push([uv2.clone(), uv4.clone(), uv3]);

                }
            }
        }

        this.computeFaceNormals();
        this.boundingSphere = new THREE.Sphere(new THREE.Vector3(), radius);
    }
}
